import React from 'react';
import { FormValuesType } from 'src/UI/dynamicUI/types';
import { FormAccordionItemList } from 'src/UI/dynamicUI/layout/DynamicEntitySection';
import { Box, Grid } from '@mantine/core';
import { FinancialFormField } from 'src/financial/financial-data/financial-item/forms/common/FinancialFormField';
import { GridPair } from 'src/financial/financial-data/financial-item/forms/common/GridPair';
import { UseFormReturnType } from '@mantine/form';

type IncomeWithdrawalFormAccordionItemListProps = {
  isEditing: boolean;
  form: UseFormReturnType<FormValuesType>;
};

export const INCOME_WITHDRAWAL = 'IncomeWithdrawal';

export const IncomeWithdrawalFormAccordionItemList = ({
  form,
  isEditing,
}: IncomeWithdrawalFormAccordionItemListProps) => {
  const untypedItems = form.getValues()[INCOME_WITHDRAWAL];
  const incomeWithdrawals = Array.isArray(untypedItems) ? untypedItems : [];

  const handleAddIncomeWithdrawal = () => {
    form.insertListItem(INCOME_WITHDRAWAL, {
      type: null,
      frequency: null,
      withdrawal_amount: null,
      payment_start_date: null,
      has_sustainability_assessment: null,
    });
  };

  return (
    <FormAccordionItemList
      value="income_withdrawal"
      label="Income withdrawals"
      counterLabel="Income withdrawals"
      button={{
        label: 'Add income withdrawal',
        onClick: handleAddIncomeWithdrawal,
      }}
      isEditing={isEditing}
      form={form}
      entityType={INCOME_WITHDRAWAL}
    >
      {incomeWithdrawals.map((_, index) => (
        <Box key={index}>
          <Grid>
            <GridPair
              first={<IncomeWithdrawalItem field="type" index={index} />}
              second={<IncomeWithdrawalItem field="frequency" index={index} />}
            />
            <GridPair
              isHighlighted
              first={<IncomeWithdrawalItem field="withdrawal_amount" index={index} />}
              second={<IncomeWithdrawalItem field="payment_start_date" index={index} />}
            />
            <GridPair
              first={<IncomeWithdrawalItem field="has_sustainability_assessment" index={index} />}
            />
          </Grid>
        </Box>
      ))}
    </FormAccordionItemList>
  );
};

type IncomeWithdrawalItemFieldProps = {
  field: string;
  index: number;
};

const IncomeWithdrawalItem = ({ field, index }: IncomeWithdrawalItemFieldProps) => (
  <FinancialFormField field={field} product={INCOME_WITHDRAWAL} index={index} />
);
